import React, { FC, memo, ChangeEvent } from 'react';
import {
  Select,
  MenuItem,
  FormControl,
  InputLabel,
  OutlinedInput,
  InputAdornment,
  IconButton
} from '@material-ui/core';
import ClearIcon from '@material-ui/icons/Clear';

interface Props {
  value: string;
  onChange: (value: string) => void;
}

const Component: FC<Props> = ({ value, onChange }) => {
  const handleChange = (event: ChangeEvent<{ value: any }>) => {
    const value = event?.target?.value;
    onChange(value);
  };

  const handleClear = () => {
    onChange('');
  };

  return (
    <FormControl variant="outlined" fullWidth>
      <InputLabel id="cheque">Action</InputLabel>
      <Select
        labelId="cheque"
        value={value === undefined ? '' : value}
        onChange={handleChange}
        label="Cheque"
        defaultValue={undefined}
        input={
          <OutlinedInput
            label="Action"
            endAdornment={
              value ? (
                <InputAdornment position="end">
                  <IconButton
                    size="small"
                    onClick={handleClear}
                    edge="end"
                    aria-label="clear selection"
                    style={{ marginRight: 20 }}
                  >
                    <ClearIcon fontSize="small" />
                  </IconButton>
                </InputAdornment>
              ) : null
            }
          />
        }
      >
        <MenuItem value={'created'}>Created</MenuItem>
        <MenuItem value={'updated'}>Updated</MenuItem>
        <MenuItem value={'deleted'}>Deleted</MenuItem>
      </Select>
    </FormControl>
  );
};

export const ActionAuditFilter = memo(Component);
